import * as types from '../actions/actionTypes';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import serverApi from '../serverApi';

export function setSource(source){
	return { type: types.IMAGE_SOURCE_SELECTED, source };
}

export function setSourceLocation(resourceLocation) {
	return { 
		type: types.IMAGE_SOURCE_LOCATION_SELECTED, 
		id: resourceLocation.id, 
		friendlyName: resourceLocation.friendlyName, 
		resourceNames: resourceLocation.resourceNames 
	};
}

export function setImageDestinationLocation(id, friendlyName, resourceNames){
	return { type: types.IMAGE_DESTINATION_SELECTED, id, friendlyName, resourceNames };
}

export function setImageName(imageName){
	return { type: types.IMAGE_NAME_SELECTED, imageName };
}

export function confirmImageCreation(imageCreationData){
	return { type: types.IMAGE_CREATION_CONFIRMED, imageCreationData };
}

export function startImagingOperation(imagingOperation) {
    return asyncActionCreator(types.IMAGE_CREATION_UPDATED, 
		serverApi.startCreateImageOperation(imagingOperation),
		json => ({ imageId: json.imageId, image: json.image }));
}



// WEBPACK FOOTER //
// ./src/js/actions/imagingWorkflowActionCreators.js